// extracted by mini-css-extract-plugin
module.exports = {"userBoxContainer":"UserCard_userBoxContainer__1CAQ6"};